//Lists navigation items to filter
const roleAccess = {
  admin: 'all',
  academic_alpha: [
    'Panel',
    'Billing',
    'Logos',
    'Inspect Reads',
    'Discover',
    'Morph',
    'Developer Tools',
    'Render Panel',
    'Invite',
    'Tests',
    'Register',
    'Settings',
  ],
  user: [
    'Panel',
    'Billing',
    'Logos',
    'Alpha Test',
    'Inspect Reads',
    'Cloud Tasks',
    'Discover',
    'Morph',
    'Basecall',
    'Developer Tools',
    'Invite',
    'Render Panel',
    'Tests',
    'Register',
    'Settings',
  ],
  beta: [
    'Panel',
    'Billing',
    'Logos',
    'Inspect Reads',
    'Discover',
    'Morph',
    'Cluster',
    'Report Bug',
    'Invite',
    'Tests',
    'Render Panel',
    'Register',
    'Settings',
  ],
  free: [
    'Panel',
    'Billing',
    'Logos',
    'Inspect Reads',
    'Quality Metrics',
    'Cloud Tasks',
    'Discover',
    'Alpha Test',
    'Morph',
    'Cluster',
    'VisualizeCluster',
    'Feedback',
    'Report Bug',
    'Visualize',
    'Basecall',
    'Developer Tools',
    'Invite',
    'Tests',
    'Render Panel',
    'Register',
    'Settings',
  ],
  default: [
    'Panel',
    'Billing',
    'Logos',
    'Inspect Reads',
    'Cloud Tasks',
    'Morph',
    'Alpha Test',
    'VisualizeCluster',
    'Discover',
    'Feedback',
    'Report Bug',
    'Cluster',
    'Invite',
    'Modify',
    'Basecall',
    'Developer Tools',
    'Render Panel',
    'Upload',
    'Tests',
    'Register',
    'Settings',
  ],
}

export default roleAccess
